import styled from 'styled-components';

export const SnapshotContainer = styled.div`
  padding-top: 15%;
  padding-left: 15%;
  align-content: center;
`;

export const SnapshotLabel = styled.label`
  font-size: 32px;
  font-weight: 600;
  color: rgb(52, 52, 52);
  font-family: 'Shell Font';
  display: block;
`;
